import React from 'react'
import { observer } from 'mobx-react'
import cn from 'classnames'
import { IProjectCloseRPC } from '@prisma/studio-types'

import ErrorStore from 'stores/error/ErrorStore'
import ActionStore from 'stores/action/ActionStore'
import ConfigStore from 'stores/config/ConfigStore'

import Dialog from 'components/dialog/Dialog'
import Button from 'components/button/Button'
import ChevronDown from 'assets/icons/chevron-down.svg'

import styles from './common.scss'

interface IProps {}

interface IState {
  isDetailsOpen: boolean
  isSendingReport: boolean
  didFailErrorReport: boolean
  errorReportId: number | null
}

class FatalError extends React.PureComponent<IProps, IState> {
  state: IState = {
    isDetailsOpen: false,
    isSendingReport: false,
    didFailErrorReport: false,
    errorReportId: null,
  }

  handleToggleDetails = () => {
    this.setState(state => ({ isDetailsOpen: !state.isDetailsOpen }))
  }

  handleDiscard = () => {
    ActionStore.discard()

    // Wait a bit to allow PersistenceStore commit
    setTimeout(() => {
      if (ConfigStore.isBrowser) {
        window.location.reload()
      } else {
        window.transport.request<IProjectCloseRPC>({
          channel: 'project',
          action: 'close',
          payload: {
            data: null,
          },
        })
      }
    }, 500) // Gives me the heebie jeebies
  }

  handleRestart = () => {
    window.location.reload()
  }

  render() {
    const { isDetailsOpen } = this.state

    return (
      <Dialog
        className={styles.container}
        error
        title="Fatal Error"
        primaryButton={
          <Button className={styles.action} onClick={this.handleRestart}>
            <>Reopen {ConfigStore.isBrowser ? 'Studio' : 'Project'}</>
          </Button>
        }
        secondaryButton={
          <Button
            ghost
            className={cn(styles.action, styles.discardBtn)}
            onClick={this.handleDiscard}
          >
            <>
              Discard all unsaved changes and close{' '}
              {ConfigStore.isBrowser ? 'Studio' : 'project'}
            </>
          </Button>
        }
      >
        <div className={styles.content}>
          <p className={styles.description}>
            A non-recoverable error has occurred and Studio has to be restarted.
            Please consider reporting this error to us by opening an issue on
            GitHub and attaching the error details.
          </p>
          <Button className={styles.reportBtn} green onClick={() => {}}>
            <a
              href="https://github.com/prisma/studio/issues/new"
              target="_blank"
              rel="noreferrer noopener"
            >
              Report error in a new GitHub issue
            </a>
          </Button>
          <Button
            ghost
            className={cn(styles.detailsBtn, {
              [styles.open]: isDetailsOpen,
            })}
            onClick={this.handleToggleDetails}
          >
            <>
              <ChevronDown />
              {isDetailsOpen ? 'Hide' : 'Show'} details
            </>
          </Button>
          {isDetailsOpen && (
            <pre className={styles.dump}>{ErrorStore.dump}</pre>
          )}
        </div>
      </Dialog>
    )
  }
}

export default observer(FatalError)
